import { render, staticRenderFns } from "./QcqQuality.vue?vue&type=template&id=1921af52&scoped=true&lang=pug&"
import script from "./QcqQuality.vue?vue&type=script&lang=ts&"
export * from "./QcqQuality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921af52",
  null
  
)

export default component.exports